import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Navbar,
  Nav,
  NavItem,
  NavLink,
  Collapse,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Button,
} from "shards-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelopeOpenText } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import styled from "styled-components";
import CustomerName from "../CustomerName/CustomerName";
import useToken from "shared/hook/useToken";
import { userSidebarContext } from "shared/hook/useOpenMenuContext";
import SidebarNav from "shared/components/SidebarNav";
import useCurrentUser from "shared/hook/useCurrentUser";

const { token, openMenu, setOpenMenu } = useToken();

const ContentHeader = styled.div`
  display: flex;
  align-items: center;
  color: #fff;
`;
const HeaderBody = styled.div`
  padding: 4px 0px;
  flex: 1 1;
`;
const TitleHeader = styled.div`
  font-size: 19px;
  @media (max-width: 767.98px) {
    display: none;
  }
`;
const SubHeader = styled.div`
  font-size: 12px;
  @media (max-width: 767.98px) {
    display: none;
  }
`;
const ButtonMenu = styled(Button)`
  border: none;
  background: transparent;
  &:hover {
    opacity: 0.7;
    background-color: transparent;
  }
`;

const StyledContactUs = styled.div`
  color: #fff;
  min-width: 130px;
  svg {
    margin-right: 10px;
  }
`;

const StyledImageLog = styled.img`
  width: 80px;
  height: 80px;
`;
const Header = ({ stickyTop }) => {
  const classes = classNames(
    "main-navbar",
    "bg-blue",
    stickyTop && "sticky-top"
  );
  const { curruntUser } = useCurrentUser();
  const [userType, setUserType] = useState(0);
  const [visible, setVisible] = useState(false);
  const { openSidebar, onSetOpenSidebar } = userSidebarContext();
  const { t, i18n } = useTranslation();

  const toggleUserActions = () => {
    setVisible(!visible);
  };

  const switchLanguage = (lang) => {
    if (lang === "en") {
      i18n.changeLanguage("en");
      localStorage.setItem("lang", "en");
    } else {
      i18n.changeLanguage("th");
      localStorage.setItem("lang", "th");
    }
  };

  useEffect(() => {
    if (curruntUser) {
        setUserType(curruntUser.detail.userType);
    }
  }, [curruntUser]);

  return (
    <>
      <div className={classes}>
        <Container className="p-0">
          <Navbar
            type="light"
            className="align-items-stretch flex-md-nowrap p-0"
          >
            <Nav navbar>
              <NavItem>
                <ContentHeader>
                  {token && userType != 0 && userType != 2 && userType != 5 && (
                    <ButtonMenu
                      onClick={() => {
                        onSetOpenSidebar(!openSidebar);
                        setOpenMenu(!openSidebar);
                      }}
                    >
                      <i className="material-icons" style={{ fontSize: 30 }}>
                        menu
                      </i>
                    </ButtonMenu>
                  )}
                  <a href="/">
                    <StyledImageLog
                      className="mr-3"
                      src={require("shared/assets/img/logox2.png")}
                      alt="logo"
                    />
                  </a>
                  <HeaderBody>
                    <TitleHeader>
                      {t('common:header.Title')}
                    </TitleHeader>
                    <SubHeader>
                      {t('common:header.SubTitle')}
                    </SubHeader>
                  </HeaderBody>
                </ContentHeader>
              </NavItem>
            </Nav>
            <Nav navbar className="ml-auto">
              <CustomerName />
            </Nav>
            <Nav navbar>
              <a href="/contact">
                <StyledContactUs>
                  <FontAwesomeIcon icon={faEnvelopeOpenText} />
                  {t('common:header.Contact')}
                </StyledContactUs>
              </a>
            </Nav>
            <Nav navbar>
              <NavItem tag={Dropdown} caret toggle={toggleUserActions}>
                <DropdownToggle
                  caret
                  tag={NavLink}
                  className="text-nowrap px-3"
                >
                  <span className="d-none d-md-inline-block mr-2">{i18n.language === "th"
                        ? "TH"
                        : "EN"
                      }</span>
                  <img
                    className="mr-2"
                    src={`${require("shared/assets/img/" +
                      (i18n.language === "th"
                        ? "th"
                        : "en"
                      )+
                      ".png")}`}
                    alt={`${
                      i18n.language === "th" ? "th" : "en"
                    }`}
                  />
                </DropdownToggle>
                <Collapse tag={DropdownMenu} right small open={visible}>
                  <DropdownItem onClick={() => switchLanguage('th')}>
                    <img
                      className="mr-2"
                      src={require("../../assets/img/th.png")}
                      alt="th"
                    />{" "}
                    TH
                  </DropdownItem>
                  <DropdownItem onClick={() => switchLanguage('en')}>
                    <img
                      className="mr-2"
                      src={require("../../assets/img/en.png")}
                      alt="en"
                    />{" "}
                    EN
                  </DropdownItem>
                </Collapse>
              </NavItem>
            </Nav>
          </Navbar>
        </Container>
      </div>
      {token && userType != 0 && userType != 2 && userType != 5 && <SidebarNav show={openSidebar}/>}
    </>
  );
};
Header.defaultProps = {
  stickyTop: true,
};
export default Header;
